import * as z from "zod";
import { attachmentSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemeFormCauseAnalysis = z.object({
  description: zRequiredString("Veuillez dÃ©finir une description"),
  // Hidden but present in fields values (via defaultValues)
  event: z
    .number({
      required_error: "Requis",
    })
    .min(1),
  // Hidden but present in fields values (via defaultValues)
  pilote: z
    .number({
      required_error: "Requis",
    })
    .min(1),
  attachedFiles: attachmentSchema,
});
